import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import CardsBorder from "../../../components/Cards/CardsBorder";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { postApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
// import { toast } from "react-toastify";
import SuccessDialog from "./SuccesDialog";

const CopyForm = ({ onOpen, onClose, data, onSave }) => {
  const [formName, setFormName] = useState("");
  const formId = data._id;
  const [showSuccess, setShowSuccess] = useState(false);

  // const handleSave = async () => {
  //   try {
  //     const copyTitle = { title: formName };
  //     const response = await postApi({
  //       apiUrl: API_URLS.COPY_STANDARD_FORM(formId),
  //       data: copyTitle
  //     });
  //     if (response.success) {
  //       // toast.success("Form Copied Successfully");
  //       setShowSuccess(true);
  //       await onSave();
  //     }
  //   } catch (error) {
  //     console.error("Error in creating copy :", error);
  //   }
  // };
  const handleSave = async () => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.COPY_STANDARD_FORM(formId),
        data: { title: formName },
      });

      if (response.success) {
        setShowSuccess(true);
        await onSave();

        setTimeout(() => {
          setShowSuccess(false);
          onClose();
        }, 2000);
      }
    } catch (error) {
      console.error("Error in creating copy:", error);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
    onClose();
  };

  return (
    <>
      <div>
        <DailogBox
          open={onOpen}
          onCancel={onClose}
          width="90%"
          maxWidth="700px"
        >
          <TextStyles color="gradient">CREATE COPY/{data.title}</TextStyles>

          <div className=" my-8 py-8 border px-4 rounded-lg">
            <label className="my-4">Name</label>
            <input
              type={"secondary"}
              // label={"Name"}
              value={formName}
              placeholder="Name of Form"
              onChange={(e) => setFormName(e.target.value)}
              className="w-full border-b focus:outline-none px-1 font-light my-2"
            />
            <div className="text-center mt-8">
              <CustomButton
                type={"primary"}
                variant={"ok"}
                buttonText={"Save"}
                className={"w-32 py-5 text-[16px]"}
                onClick={handleSave}
              />
            </div>
          </div>
        </DailogBox>
      </div>
      <SuccessDialog open={showSuccess} onClose={handleCloseSuccess} />
    </>
  );
};

export default CopyForm;
